import {useSelector} from 'react-redux';
import {selectCompanies} from '../../../store/companies';
import ProjectLabel from '../ProjectLabel';

const ProjectsFilter = ({projects, selectedIds, onChange}) => {
    const companies = useSelector(selectCompanies);
    const allIds = projects.map(p => p.id);
    const allSelected = allIds.length > 0 && selectedIds.length === allIds.length;

    const toggle = (id) => {
        const set = new Set(selectedIds);
        set.has(id) ? set.delete(id) : set.add(id);
        onChange(Array.from(set));
    };

    if (!projects.length) return null;

    return (
        <section className="filter-card">
            <div className="filter-card__header">
                <div className="filter-card__title">Projects</div>
                <div className="filter-card__actions">
                    <button
                        type="button"
                        className="filter-action"
                        onClick={() => onChange(allIds)}
                        disabled={allSelected}
                        title="Select all"
                    >✓</button>
                    <button
                        type="button"
                        className="filter-action"
                        onClick={() => onChange([])}
                        disabled={!selectedIds.length}
                        title="Clear"
                    >×</button>
                </div>
            </div>
            <div className="filter-list">
                {projects.map(p => (
                    <label key={p.id} className="filter-check">
                        <input
                            type="checkbox"
                            checked={selectedIds.includes(p.id)}
                            onChange={() => toggle(p.id)}
                        />
                        <ProjectLabel
                            project={p}
                            company={companies.find(c => c.id === p.companyId) ?? null}
                        />
                    </label>
                ))}
            </div>
        </section>
    );
};

export default ProjectsFilter;